import { z } from 'zod';

export const BalanceSheetResponseSchema = z.object({
  data: z.object({
    income: z.coerce.number(),
    expense: z.coerce.number(),
    accounts_receivable: z.coerce.number(),
    accounts_payable: z.coerce.number(),
    total: z.coerce.number(),
  }),
});

export type BalanceSheetResponseType = z.infer<
  typeof BalanceSheetResponseSchema
>['data'];
